export const HTL_STOCK = 'HTL STOCK'
export const ECO_STOCK = 'ECO STOCK'
export const ADMIN_PANEL = 'ADMIN PANEL'
export const SALES_STATS = 'SALES STATS'
export const TLP_POINT = 'TLP POINT'
export const TRIP_POINT = 'TRIP POINT'
export const NEXEN_POINT = 'NEXEN POINT'
export const HTS_POINT_SYSTEM = 'HTS POINT SYSTEM'
export const STAFF_BENEFIT_ADMIN = 'STAFF BENEFIT ADMIN'
export const REQUISITION_FORM = 'REQUISITION FORM'
export const TYREHUB_POINT = 'TYREHUB TRIP'
export const BATTERY_INCENTIVE_POINT = 'BATTERY INCENTIVE TRIP'
export const MOBIL_NORTH_CHINA_TRIP_POINT = 'MOBIL NORTH CHINA TRIP'
export const COMPANY_MAPPING_ADMIN = 'COMPANY MAPPING ADMIN'
export const FIESTA_POINT = 'FIESTA POINT'
export const SALES_COMMISSION = 'SALES COMMISSION'
export const SALES_PAYOUT = 'SALES PAYOUT'

export const permissions = {
  HTL_STOCK,
  ECO_STOCK,
  ADMIN_PANEL,
  SALES_STATS,
  TLP_POINT,
  TRIP_POINT,
  NEXEN_POINT,
  HTS_POINT_SYSTEM,
  STAFF_BENEFIT_ADMIN,
  REQUISITION_FORM,
  TYREHUB_POINT,
  BATTERY_INCENTIVE_POINT,
  MOBIL_NORTH_CHINA_TRIP_POINT,
  COMPANY_MAPPING_ADMIN,
  FIESTA_POINT,
  SALES_COMMISSION,
  SALES_PAYOUT,
}
